import { FlowAction } from '~/graphql/types';
import type { ClientFlowAction } from '~/graphql/types.client';
import type { HandlerId } from '../../../../../nodeTypes/components/IfElseCard/types';

type Params = {
  isChoosingPathToConnect: boolean;
  copiedAction: ClientFlowAction | undefined;
  sourceKey: HandlerId | undefined;
  copiedActionById: Map<string, ClientFlowAction>;
};

/**
 * Checks if the edge is an if else open path choice edge
 */
const getIsIfElseOpenPathChoiceEdge = ({
  isChoosingPathToConnect,
  copiedAction,
  sourceKey,
  copiedActionById,
}: Params): boolean => {
  if (!isChoosingPathToConnect) return false;
  if (copiedAction?.actionType !== FlowAction.IfElse) return false;
  if (sourceKey == null) return false;

  switch (sourceKey) {
    case 'trueChild':
      return (
        !copiedAction.trueChildId ||
        !copiedActionById.has(copiedAction.trueChildId)
      );
    case 'falseChild':
      return (
        !copiedAction.falseChildId ||
        !copiedActionById.has(copiedAction.falseChildId)
      );
    default:
      return false;
  }
};

export default getIsIfElseOpenPathChoiceEdge;
